import api from '../api'
const baseUrl = '/academy/api/AdminCourse'
const skillUpCategoryProvider = {
  AddCategoryCourse(params) {
    return api.post(`${baseUrl}/AddCategory`, params)
  },
  updateCategoryCourse(params) {
    return api.put(`${baseUrl}/EditCategory`, params)
  },
  getCategoriesCourse(id) {
    return api.get(`${baseUrl}/GetCategory/id?id=${id}`)
  },
  deleteCategoryCourse(id) {
    return api.delete(`${baseUrl}/DeleteCategory/${id}`)
  },
}

export default skillUpCategoryProvider
